<template>
    <div class="cases-information">
        <el-row>
            <el-col :span="24">
                <h1 class="cases-title">用户案例场景演示</h1>
            </el-col>
        </el-row>
        <!-- 轮播区域开始 -->
        <div class="cases-swiper-wrapper">
            <div class="custom-swiper">
                <div
                    v-for="(caseItem, idx) in cases"
                    :key="caseItem.id"
                    class="news-swiper-slide"
                    :class="{
                        center: idx === currentIndex,
                        left: idx === leftIndex,
                        right: idx === rightIndex
                    }"
                    v-show="[leftIndex, currentIndex, rightIndex].includes(idx)"
                    @touchstart="onTouchStart"
                    @touchmove="onTouchMove"
                    @touchend="(e) => onTouchEnd(e, caseItem)"
                >
                    <el-card shadow="hover" class="news-card" style="cursor:pointer;">
                        <img :src="(caseItem.img ? caseItem.img.split(',')[0] : '')" class="cases-image" />
                        <div class="main-image-overlay" v-if="idx === currentIndex">
                            <div class="main-title">
                                {{ caseItem.title ? caseItem.title.replace(/(\(|（)[^）)）]*(\)|）)/g,
                                    '') : '' }}
                            </div>
                            <div class="main-subtitle">
                                用户痛点
                                <span style="margin: 0 8PX;">|</span>
                                {{ caseItem.refine }}
                            </div>
                            <p class="main-content">{{ caseItem.effect }}</p>
                            <button class="main-button" @click.stop="viewDetails(caseItem.id)">了解详情 ></button>
                        </div>
                    </el-card>
                </div>

            </div>
        </div>
        <!-- 轮播区域结束 -->
        <el-row>
            <el-col :span="24" class="view-more">
                <a href="/all_user_cases?source=all_user_cases&navUserCaseType=1">查看更多用户案例 > </a>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { caseListByType } from "@/api/dataManeger.js";
import { IMG_BASE_URL } from "@/utils/index.js";

export default {
    name: 'NewsInformation',
    data() {
        return {
            cases: [],
            currentIndex: 0,
            timer: null,
            touchStartX: 0,
            touchEndX: 0,
        };
    },
      watch: {
    // 监听 URL 的变化
    "$route.fullPath": {
      immediate: true,
      handler() {
        this.currentIndex = 0;
      },
    },
  },
    computed: {
        IMG_BASE_URL() {
            return IMG_BASE_URL;
        },
        leftIndex() {
            const len = this.cases.length;
            return (this.currentIndex - 1 + len) % len;
        },
        rightIndex() {
            const len = this.cases.length;
            return (this.currentIndex + 1) % len;
        }
    },
    methods: {
        getCases() {
            caseListByType({ type: this.activeCategoryId }).then((res) => {
                if (res) {
                    this.cases = res.result.filter(item => item.img && item.img.trim() !== '');
                }
            })
        },


        viewDetails(id) {
            const caseItem = this.cases.find((item) => item.id === id);
            if (caseItem) {
                this.$router.push({ path: '/user_case_detail', query: { source: caseItem.route, id: id, userCaseType: this.activeCategoryId } });
            }
        },
        prevSlide() {
            const len = this.cases.length;
            this.currentIndex = (this.currentIndex - 1 + len) % len;
            this.restartAutoPlay();
        },
        nextSlide() {
            const len = this.cases.length;
            this.currentIndex = (this.currentIndex + 1) % len;
            this.restartAutoPlay();
        },
        startAutoPlay() {
            this.timer = setInterval(() => {
                this.nextSlide();
            }, 3000);
        },
        stopAutoPlay() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        restartAutoPlay() {
            this.stopAutoPlay();
            // this.startAutoPlay();
        },
        onTouchStart(e) {
            this.touchStartX = e.touches[0].clientX;
            this.touchEndX = this.touchStartX; // 初始化
        },
        onTouchMove(e) {
            this.touchEndX = e.touches[0].clientX;
        },
        onTouchEnd(e, caseItem) {
            const deltaX = this.touchEndX - this.touchStartX;
            if (Math.abs(deltaX) > 30) {
                // 滑动
                if (deltaX > 0) {
                    this.prevSlide();
                } else {
                    this.nextSlide();
                }
            } else if (Math.abs(deltaX) < 10 && caseItem) {
                // 认为是点击
                // this.viewDetails(caseItem.id);
            }
            // 重置
            this.touchStartX = 0;
            this.touchEndX = 0;
        }
    },
    mounted() {
        this.getCases();
        // this.startAutoPlay();
    },
    beforeDestroy() {
        this.stopAutoPlay();
    }
};
</script>

<style lang="scss" scoped>
.cases-information {
    width: 100%;

    margin: 0 auto;
    text-align: center;
    background: #FBFBFB;
}

.cases-title {
    font-size: 16PX;
    font-weight: bold;
    margin-bottom: 20PX;
    margin-top: 40PX;
    color: #1E242A;
}

/* 新增swiper样式 */
.cases-swiper-wrapper {
    width: 100%;
    margin: 0 auto 0PX auto;
    overflow: visible;
}

.custom-swiper {
    position: relative;
    width: 100%;
    /* min-height: 200PX; */
    height: 171px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.news-swiper-slide {
    position: absolute;
    top: 0;
    bottom: 0;
    transition: all 0.3s;
    opacity: 0;
    pointer-events: none;
    z-index: 1;
    /* 默认隐藏 */
}

.news-swiper-slide.center {
    /* left: 20%; */
    width: calc(100% - 60px);
    opacity: 1;
    transform: scale(1);
    z-index: 3;
    pointer-events: auto;
}

.news-swiper-slide.left {
    left: 0;
    width: 18px;
    opacity: 1;
    transform: scale(1);
    z-index: 2;
    pointer-events: auto;
}

.news-swiper-slide.right {
    right: 0;
    width: 18px;
    opacity: 1;
    transform: scale(1);
    z-index: 2;
    pointer-events: auto;
}

/* 保证间距10PX */
.news-swiper-slide.center {
    /* margin: 0 16PX; */
}

.news-swiper-slide.left,
.news-swiper-slide.right {
    margin: 0PX;
}

.swiper-controls {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 0;
    display: flex;
    justify-content: space-between;
    pointer-events: none;
}

.swiper-arrow {
    background: rgba(0, 0, 0, 0.2);
    color: #fff;
    border-radius: 50%;
    width: 28PX;
    height: 28PX;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18PX;
    cursor: pointer;
    pointer-events: auto;
    user-select: none;
}

.swiper-arrow.left {
    margin-left: 8PX;
}

.swiper-arrow.right {
    margin-right: 8PX;
}

.swiper-dots {
    position: absolute;
    left: 50%;
    bottom: 10PX;
    transform: translateX(-50%);
    display: flex;
    gap: 6PX;
}

.dot {
    width: 8PX;
    height: 8PX;
    border-radius: 50%;
    background: #ccc;
    display: inline-block;
    cursor: pointer;
}

.dot.active {
    background: #1E242A;
}

.cases-image {
    width: 100%;
    height: 171px;
    object-fit: cover;
    /* border-radius: 8PX; */
    /* 添加圆角 */
    background-size: cover;
    position: relative;
}


.left .cases-image {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}

.right .cases-image {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}

.center .cases-image {
    border-radius: 8PX;
}

.view-more {
    margin-top: 20PX;
    margin-bottom: 40PX;
}

.view-more a {
    text-decoration: none;
    color: #1E242A;
    font-size: 10PX;
}



::v-deep .el-card {
    border: none
}

.news-swiper-slide,
.news-swiper-slide.center,
.news-swiper-slide.left,
.news-swiper-slide.right {
    height: 171px;
}

::v-deep .el-card__body {
    padding: 0px;
}

.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
    box-shadow: none;
}

.main-image-overlay {
    position: absolute;
    bottom: 40PX;
    /* 根据1920×1080分辨率调整 */
    left: 40PX;
    color: #fff;
    height: 171px;
    border-radius: 8px;
    background: linear-gradient(90deg, rgba(30, 36, 42, 0.6) 0%, rgba(30, 36, 42, 0.1) 100%);
    z-index: 2;
    /* 确保内容在背景色之上 */
    text-align: left;
    top: 0PX;
    left: 0PX;
    /* width: 480PX; */
    /* height: 100%; */
    padding: 16PX;
    padding-top: 39PX;
}

.main-title {
    font-size: 12PX;
    font-weight: bold;
    margin-bottom: 6PX;
}

.main-subtitle {
    font-size: 10PX;
    margin-bottom: 8PX;
    opacity: 0.8;
    color: #fff;
    font-weight: normal;
    white-space: nowrap;
    /* 不换行 */

    text-overflow: ellipsis;
    /* 显示省略号 */
}

.main-content {
    font-size: 10PX;
    margin-bottom: 10PX;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    /* 限制为1行 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    /* 超出隐藏 */
    text-overflow: ellipsis;
    white-space: normal;
    /* 允许换行 */
}

.main-button {
    width: 60PX;
    height: 20PX;
    border-radius: 4PX;
    background: rgba(255, 255, 255, 0.1);

    border: 1PX solid rgba(255, 255, 255, 0.4);
    color: #fff;
    font-size: 7PX;
    cursor: pointer;
    text-align: center;
    transition: all 0.3s;
}

.main-button:hover {
    border-color: #0f6bf6;
    color: #0f6bf6;
}
</style>
